/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from 'react';
import { BaseTable } from 'containers/application-manager/base-table/base-table';
import { FaFundingStatusEnum } from 'constants/enums';
import { Box, Typography } from '@mui/material';
import { VisibilityOutlined } from '@mui/icons-material';
import { PauseYellowIcon, PlayGreenIcon, StopRedIcon } from 'components/icons/icons';
import FinancialAssistanceFundsDetail from './detail';

export interface ITableProps {
  searchTerm: string | undefined;
  loading?: boolean;
  data: IResponse;
}

export interface IResponse {
  results: IResult[];
  totalCount: number;
}

export interface IResult {
  id: number;
  program_name: string;
  category: string;
  type: string;
  eligibility: string;
  manufacturer: string;
  medication: string;
  funding_status: string;
  therapeutic_area: string;
  is_waitlist: boolean;
  children: undefined[];
}

export const FinancialAssistanceFundsTable: React.FC<ITableProps> = (props): JSX.Element => {
  const [selectedProgram, setSelectedProgram] = useState<number>(0);

  return (
    <>
      <FinancialAssistanceFundsDetail programId={selectedProgram} />
      <BaseTable<IResponse, IResult, undefined>
        actionsPermitted
        enableParentCheckboxes={false}
        enableChildCheckboxes={false}
        orderByDefaultParent="program_name"
        paginationQueryParamSettings={{
          pageSizeQueryStringKey: 'pageSize',
          pageNumberQueryStringKey: 'pageNumber',
          searchTermQueryStringKey: 'searchTerm',
          sortPropQueryStringKey: 'sortProp',
          sortOrderQueryStringKey: 'sortOrder',
        }}
        childPkSelector={p => ''}
        parentPkSelector={p => p.id}
        searchTerm={props.searchTerm}
        columnSettings={[
          {
            label: 'Program / Brand',
            sortable: true,
            parentKey: 'program_name',
            hideLeftPadding: true,
          },
          {
            label: 'Fund Status',
            sortable: true,
            parentKey: 'funding_status',
            parentValueFormatter: () => '',
            parentComponent: parent => {
              const isOpen = parent.funding_status === FaFundingStatusEnum.Normal;
              // Default to closed if not open or waitlist
              let text = 'Closed';
              let StatusIcon = StopRedIcon;

              if (parent.is_waitlist) {
                text = 'Waitlist';
                StatusIcon = PauseYellowIcon;
              } else if (isOpen) {
                text = 'Open';
                StatusIcon = PlayGreenIcon;
              }

              return (
                <Box display="flex" alignItems="center">
                  <StatusIcon />
                  <Typography variant="body2">{text}</Typography>
                </Box>
              );
            },
          },
          {
            label: 'Therapeutic Area',
            sortable: true,
            parentKey: 'therapeutic_area',
          },
          {
            label: 'Type',
            sortable: true,
            parentKey: 'type',
          },
          {
            label: 'Eligibility',
            sortable: true,
            parentKey: 'eligibility',
          },
          {
            label: 'Manufacturer',
            sortable: true,
            parentKey: 'manufacturer',
          },
          {
            label: 'Medication',
            sortable: true,
            parentKey: 'medication',
          },
          {
            label: 'Details',
            parentComponent: parent => {
              return (
                <>
                  <VisibilityOutlined
                    onClick={(e: React.MouseEvent) => {
                      e.stopPropagation();
                      setSelectedProgram(parent.id);
                      // setEditingUserId(parent.id);
                    }}
                  />
                </>
              );
            },
          },
        ]}
        loading={props.loading}
        dataSet={props.data ?? []}
        triggerReload={new Date()}
      />
    </>
  );
};
